import { render, staticRenderFns } from "./QuotaMeter.vue?vue&type=template&id=961919fe&scoped=true"
import script from "./QuotaMeter.vue?vue&type=script&lang=js"
export * from "./QuotaMeter.vue?vue&type=script&lang=js"
import style0 from "./QuotaMeter.vue?vue&type=style&index=0&id=961919fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961919fe",
  null
  
)

export default component.exports